__turbopack_context__.v({
  "brandName": "ProductCard-module-scss-module__FZ0HCq__brandName",
  "buyCanadianWrapper": "ProductCard-module-scss-module__FZ0HCq__buyCanadianWrapper",
  "card": "ProductCard-module-scss-module__FZ0HCq__card",
  "comparisonCheckbox": "ProductCard-module-scss-module__FZ0HCq__comparisonCheckbox",
  "currentPrice": "ProductCard-module-scss-module__FZ0HCq__currentPrice",
  "dealsBannerContainer": "ProductCard-module-scss-module__FZ0HCq__dealsBannerContainer",
  "discountBadge": "ProductCard-module-scss-module__FZ0HCq__discountBadge",
  "groupPrice": "ProductCard-module-scss-module__FZ0HCq__groupPrice",
  "image": "ProductCard-module-scss-module__FZ0HCq__image",
  "imagePad": "ProductCard-module-scss-module__FZ0HCq__imagePad",
  "imageWrapper": "ProductCard-module-scss-module__FZ0HCq__imageWrapper",
  "info": "ProductCard-module-scss-module__FZ0HCq__info",
  "link": "ProductCard-module-scss-module__FZ0HCq__link",
  "mini": "ProductCard-module-scss-module__FZ0HCq__mini",
  "onTint": "ProductCard-module-scss-module__FZ0HCq__onTint",
  "originalPrice": "ProductCard-module-scss-module__FZ0HCq__originalPrice",
  "price": "ProductCard-module-scss-module__FZ0HCq__price",
  "priceGroup": "ProductCard-module-scss-module__FZ0HCq__priceGroup",
  "productInfo": "ProductCard-module-scss-module__FZ0HCq__productInfo",
  "productName": "ProductCard-module-scss-module__FZ0HCq__productName",
  "ratingValue": "ProductCard-module-scss-module__FZ0HCq__ratingValue",
  "ratings": "ProductCard-module-scss-module__FZ0HCq__ratings",
  "reviewCount": "ProductCard-module-scss-module__FZ0HCq__reviewCount",
  "swatches": "ProductCard-module-scss-module__FZ0HCq__swatches",
  "tagsContainer": "ProductCard-module-scss-module__FZ0HCq__tagsContainer",
});
